module.exports = __webpack_public_path__ + "static/img/303.98d2518.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kittens/201224/303.jpg
// module id = B5Za
// module chunks = 0